<div>
   <p class="Page-Details">{{'DTC_Select_Info'|translate}}</p>
</div>
<div>
    <table class="table table-bordered table-striped" style="border: none;">
        <thead style="font-weight: bold">
            <tr>
                <td class="title-column">{{'Date Requested'|translate}}</td>
                <td class="title-column">{{'Module'|translate}}</td>
                <td class="title-column">{{'DTC'|translate}}</td>
                <td class="title-column">{{'Description'|translate}}</td>
                <td class="title-column">{{'Failure Type'|translate}}</td>
                <td class="title-column">{{'Status Byte'|translate}}</td>
            </tr>
        </thead>
        <tr *ngFor="let u of dtcList" [class.selectedRow]="rowIsSelected(u.count)" (click)="onRowClick(u.count)"
            style="cursor: pointer;">
            <td class="row-left title">{{u.timestamp}}</td>
            <td class="row-mid title">{{u.module}}</td>
            <td class="row-mid title">{{u.dtc}}</td>
            <td class="row-left title">{{u.description}}</td>
            <td class="row-mid title">{{u.failureType}}</td>
            <td class="row-mid title">{{u.statusType}}</td>
        </tr>
    </table>
    <p *ngIf="!isHistoricalDTCPresent" class="NoHDTC">{{'No_HistoricalDTC_Msg'|translate}}</p>
</div>
<div id="mybutton">
    <button type="button" *ngIf="isHistoricalDTCPresent" class="btn btn-primary mr-3 shadow-none"
    [disabled]='disableImportDTCBtn' (click)="importDTCData()">{{'btn_Import_DTC'|translate}}</button>
    <button type="button" class="btn btn-primary mr-3 shadow-none" [disabled]='disableSymptomsSelectionBtn'
        (click)="NavigateSymptomSelection()">{{'btn_Exit'|translate}}</button>
</div>

<div *ngIf=showloader class="loader2">
    <img id="loadSpinnerImg" src="assets/images/ajax-loader.gif" width="100" height="100">
</div>